import { useTranslation } from "react-i18next";
import Page from "app/shared/UI/Layout/Page";
import ProspectListingPageContent from "app/components/prospect/ProspectListingPageContent";
import ProspectFilters from "app/components/prospect/ProspectFilters";

const ProspectListingPage = (props) => {
  const { t } = useTranslation();

  return (
    <Page
      hasDrawer={true}
      drawerComponent={ProspectFilters}
      pageTitle={t("pageTitle.lookupProspect")}
      hasBackButton={false}
      contentComponent={ProspectListingPageContent}
      isDrawerOpen={true}
      {...props}
    />
  );
};

export default ProspectListingPage;
